<template>
	<div>
		<el-card>
			<el-form ref="form" :model="form" label-width="80px">
				<el-form-item label="标题" prop="title">
					<el-input v-model="form.title"></el-input>
				</el-form-item>
				<el-form-item label="封面">
					<el-upload ref="uUpload" class="avatar-uploader" :headers="headers" :action="action" :on-success="uploadSuccess">
						<img v-if="form.media" :src="form.media" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				<el-form-item label="文章内容">
					<editor-bar ref="editor" @change="change" v-model="form.content"></editor-bar>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" :loading="btnLoading" :disabled="btnDisabled" @click="onSubmit">提交</el-button>
				</el-form-item>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	import EditorBar from '../../components/wangeditor/index.vue';
	export default {
		components: {
			EditorBar
		},
		data() {
			return {
				action: this.$H.domain + "common/uploadFile",
				headers: {
					token: this.$store.state.userInfo.token
				},
				form: {
					title: '',
					media: '',
					content: ''
				},
				btnLoading: false,
				btnDisabled: false
			}
		},
		methods: {
			onSubmit() {
				this.btnLoading = true;
				this.btnDisabled = true;
				
				if(!this.form.title){
					this.$message.error("标题不能为空");
					this.btnLoading = false;
					this.btnDisabled = false;
					return;
				}

				if(!this.form.media){
					this.$message.error("请上传封面");
					this.btnLoading = false;
					this.btnDisabled = false;
					return;
				}
				if(!this.form.content){
					this.$message.error("图文内容不能为空");
					this.btnLoading = false;
					this.btnDisabled = false;
					return;
				}
				this.$H.post("post/articleAdd", this.form).then(res => {
					if (res.code === 200) {
						this.$refs.form.resetFields();
						this.form.content = "";
						this.form.media = "";
						this.$refs.uUpload.clearFiles();
						this.$refs.editor.clear();
						
						this.$message.success(res.msg)
					}

					this.btnLoading = false;
					this.btnDisabled = false;
				})
			},
			uploadSuccess(e) {
				this.form.media = e.result.url;
			},
			change(html) {
				this.form.content = html;
			}
		}
	}
</script>

<style>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 145px;
		height: 145px;
		line-height: 145px;
		text-align: center;
	}

	.avatar {
		width: 145px;
		height: 145px;
		display: block;
	}
</style>
